import { Component } from '../../scripts/component';

class ReleasePdpCountdown extends Component {
  constructor() {
    super();
    this.formSubmitted = false;
  }
  connectedCallback() {
    super.connectedCallback();
    this.startCounter();

    if (this.dataset.expectedRelease !== 'true') {
      this.updateCounter();
    }

    // Listen for form submission to prevent reload
    document.addEventListener('release-form-submitted', () => {
      this.formSubmitted = true;
    });

    this.initStickyPosition();
  }

  initStickyPosition() {
    const wrapper = this.closest('.data-release-countdown-sticky__wrapper');
    const header = document.querySelector('header-component');
    if (!wrapper || !header) return;

    let ticking = false;
    const update = () => {
      wrapper.style.top = (header.getBoundingClientRect().bottom + 30) + 'px';
      ticking = false;
    };

    this.stickyScrollHandler = () => {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    };
    window.addEventListener('scroll', this.stickyScrollHandler, { passive: true });
    update();
  }

  startCounter() {
    this.releaseDate = this.dataset.releaseDate;
    if (!this.releaseDate) return;

    this.releaseDate = new Date(this.releaseDate * 1000);

    this.days = this.querySelector('[data-days]');
    this.hours = this.querySelector('[data-hours]');
    this.minutes = this.querySelector('[data-minutes]');
    this.seconds = this.querySelector('[data-seconds]');
  }

  updateCounter() {
    if (!this.releaseDate) return;

    const now = new Date();
    const diff = this.releaseDate - now;

    const days = Math.max(0, Math.floor(diff / (1000 * 60 * 60 * 24)));
    const hours = Math.max(0, Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
    const minutes = Math.max(0, Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)));
    const seconds = Math.max(0, Math.floor((diff % (1000 * 60)) / 1000));

    if (this.days) this.days.textContent = String(days).padStart(2, '0');
    if (this.hours) this.hours.textContent = String(hours).padStart(2, '0');
    if (this.minutes) this.minutes.textContent = String(minutes).padStart(2, '0');
    if (this.seconds) this.seconds.textContent = String(seconds).padStart(2, '0');

    if (diff < 0) {
      if (!this.formSubmitted) {
        location.reload();
      }
      return;
    }

    setTimeout(() => this.updateCounter(), 1000);
  }

  disconnectedCallback() {
    if (this.stickyScrollHandler) {
      window.removeEventListener('scroll', this.stickyScrollHandler);
    }
    super.disconnectedCallback();
  }
}

if (!customElements.get('release-pdp-countdown')) {
  customElements.define('release-pdp-countdown', ReleasePdpCountdown);
}
